export default __webpack_public_path__ + "static/assets/SL-cards-bg.ce6f7083.jpg";